import React, { useEffect, useState } from 'react';
import AnimatedNumber from "animated-number-react";
import { useProject } from "../../../providers/ClientProjectProvider";
import { useAuth } from '../../../providers/AuthProvider';
import HideTalentPricingTooltip from '../../clients/HideTalentPricingTooltip';

const ProjectFixedSummary = ({ isContract, project, candidate, ...props }) => {
    const getSections = () => isContract ? project.sowBriefSections(candidate) : project.briefSections(candidate);
    const [duration, setDuration] = useState(0);
    const { auth } = useAuth();

    useEffect(() => {
        const resetDuration = () => {
            setDuration(1000)
        }
        resetDuration();
    }, [project.hourlyTotal(), project.estimated_cost, project.positions?.length]);

    if (props.biddingBrief) {
        return (
            <div className="bg-light-gray p-3 rounded-lg mb-8 flex flex-row flex-wrap">
                {TB.map(getSections(), section => {
                    const value = section.value();
                    const shouldTruncate = String(value.length) > 40;
                    const shouldAnimate = TB.isNumber(value);
                    const format = section.format || ((v) => Number(v).toFixed(0));
                    const shouldHideCurrency = String(value).includes('$') && !auth.canViewTalentPricing();

                    return (
                        <div key={TB.slugify(section.label)} className="flex-grow mb-4 sm:mb-0">
                            <p className="text-xs text-light-gray4 pb-2 font-semibold whitespace-nowrap">
                                {section.label}
                            </p>
                            {shouldHideCurrency ? (
                                <HideTalentPricingTooltip />
                            ) : (
                                <p className="text-base whitespace-nowrap" title={shouldTruncate ? value : undefined}>
                                    {shouldAnimate ? (
                                        <AnimatedNumber
                                            value={value}
                                            formatValue={format}
                                            duration={duration}
                                        />
                                    ) : shouldTruncate ? TB.truncate(value, { length: 40 }) : value}
                                </p>
                            )}
                        </div>
                    )
                })}
            </div>
        )
    }

    return (
        <div className="est-brief">

            <div className="est-brief-info">
                {TB.map(getSections(), section => {
                    const value = section.value();
                    const shouldTruncate = String(value.length) > 40;
                    const shouldAnimate = TB.isNumber(value);
                    const format = section.format || ((v) => Number(v).toFixed(0));
                    const shouldHideCurrency = String(value).includes('$') && !auth.canViewTalentPricing();

                    return (
                        <div key={TB.slugify(section.label)} className="est-brief-section">
                            <p className="est-brief-section-label">
                                {section.label}
                            </p>
                            {shouldHideCurrency ? (
                                <HideTalentPricingTooltip />
                            ) : (
                                <p className="est-brief-section-value" title={shouldTruncate ? value : undefined}>
                                    {shouldAnimate ? (
                                        <AnimatedNumber
                                            value={value}
                                            formatValue={format}
                                            duration={duration}
                                        />
                                    ) : shouldTruncate ? TB.truncate(value, { length: 40 }) : value}
                                </p>
                            )}
                        </div>
                    )
                })}
            </div>
        </div>
    );
};


export {
    ProjectFixedSummary
}

const ProjectSummary = (props) => {
    const { project } = useProject();

    return (
        <ProjectFixedSummary project={project} {...props} />
    )
}

export default ProjectSummary;